'use es6';

export var getCanTrial = function getCanTrial(state, upgradeProduct) {
  if (!state.trialState) return false;
  var trialNames = state.trialState.map(function (trial) {
    return trial.name;
  });
  return trialNames.indexOf(upgradeProduct) !== -1;
};